import { render, staticRenderFns } from "./cardMetodicsFile.vue?vue&type=template&id=29a5c61c&scoped=true"
import script from "./cardMetodicsFile.vue?vue&type=script&lang=js"
export * from "./cardMetodicsFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a5c61c",
  null
  
)

export default component.exports